import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import { Stack } from "@mui/system";
import { Divider } from "@mui/material";

function DynamicTable({ row, columns }) {
  function CustomFooter({ rows }) {
  
    const total = rows.reduce((sum, row) => sum + row?.Qty, 0);
    const totalAmount = rows.reduce((sum, row) => sum + row?.Total, 0);

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: 10,
          background: "#f0f0f0",
        }}
      >
        <Stack direction={"row"} gap={2}>
          <strong>Total Amount: {totalAmount}</strong>
          <Divider orientation="vertical" sx={{ borderColor: "black" }} />
          <strong>Total Qty: {total}</strong>
        </Stack>
      </div>
    );
  }
  return (
    <>
 
      <DataGrid
        rows={row}
        columns={columns}
        slots={{
          footer: () => <CustomFooter rows={row} />,
        }}
        hideFooterPagination
        sx={{ height: 530 }}
      />
    </>
  );
}

DynamicTable.propTypes = {
  row: PropTypes.array,
  columns: PropTypes.array,
  CustomFooter: PropTypes.any,
};

export default DynamicTable;
